import { createSlice } from "@reduxjs/toolkit";
import { CentroCustoDtoModel } from "../../../models/centroCusto/centroCustoDtoModel";
import { BuscarRateioCentroCustoModel } from "../../../models/rateioCentroCusto/buscarRateioCentroCustoModel";
import { RateioCentroCustoModel } from "../../../models/rateioCentroCusto/rateioCentroCustoModel";
import { buscarRateioCentroCusto } from "../../../services/rateioCentroCustoService";
import { resetAll } from "../../actions/actions";

export interface RateioCentroCustoState {
  //buscar rateio centro custo
  loading: boolean;
  busca: BuscarRateioCentroCustoModel;
  list: RateioCentroCustoModel[];
  entity: RateioCentroCustoModel;
  //internal
  page: string;
  modalDeletar: boolean;
  listaNodes: CentroCustoDtoModel[];
}

const initialState: RateioCentroCustoState = {
  //buscar rateio centro custo
  loading: false,
  busca: {
    id: null,
    pesquisar: null,
    automatico: null,
    ativo: null,
  } as BuscarRateioCentroCustoModel,
  list: [],
  entity: {} as RateioCentroCustoModel,
  //internal
  page: "geral",
  modalDeletar: false,
  listaNodes: [],
};

export const rateioCentroCustoSlice = createSlice({
  name: "rateioCentroCusto",
  initialState,
  reducers: {
    //buscar rateio centro custo
    setBuscaRateioCentroCusto: (state, action) => {
      state.busca = action.payload;
    },
    setEntityRateioCentroCusto: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setPageRateioCentroCusto: (state, action) => {
      state.page = action.payload;
    },
    setModalDeletarRateioCentroCusto: (state, action) => {
      state.modalDeletar = action.payload;
    },
    setListaNodes: (state, action) => {
      state.listaNodes = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar rateio centro custo
    builder.addCase(buscarRateioCentroCusto.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarRateioCentroCusto.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarRateioCentroCusto.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar rateio centro custo
  setBuscaRateioCentroCusto,
  setEntityRateioCentroCusto,
  //internal
  setPageRateioCentroCusto,
  setModalDeletarRateioCentroCusto,
  setListaNodes,
} = rateioCentroCustoSlice.actions;

export default rateioCentroCustoSlice.reducer;
